import { api } from '@api';
import { cloud } from '@data/cloud/CloudManager';
import { useShowToast } from '@hooks/useShowToast';
import { uploadIntent } from '@prisma/client';
import { ChikoReject, ERRORS_TYPES } from '@specs/specs';
export type uploadImageType = (croppedImg: string) => Promise<{
  status: 'success';
  intent: uploadIntent;
} | ChikoReject<'cloud.intent.error' | 'upload.image.413' | 'please.check.your.file'>>;
export const useUploadCropperImage = () => {
  const {
    showToast
  } = useShowToast();
  const {
    mutateAsync: createAvatarUploadMutate
  } = api.SocialManager.createAvatarUpload.useMutation({
    mutationKey: ['SocialManager.createAvatarUpload'],
    onSuccess: async data => {
      if (data.status === 'reject') showToast({
        variant: 'error',
        text: data.code
      });
    },
    onError: () => {
      showToast({
        variant: 'error',
        text: 'error.default'
      });
    }
  });
  const uploadImage: uploadImageType = async croppedImg => {
    const data = await createAvatarUploadMutate();
    if (data.status !== 'success') return data;
    try {
      const blob = await fetch(croppedImg).then(res => res.blob());
      const body = new FormData();
      body.append('file', blob);
      const res = await fetch(data.intent.uri, {
        method: 'POST',
        body
      });
      if (res.status === 413) throw new Error('upload.image.413');
      const fetchData = await res.json();
      if (!cloud.response.isCloudInfo(fetchData)) {
        throw new Error('please.check.your.file');
      }
      return data;
    } catch (e) {
      console.error('Error', e);
      if (e instanceof Error) {
        const text = e.message === 'upload.image.413' ? e.message : 'please.check.your.file' satisfies ERRORS_TYPES;
        return {
          status: 'reject',
          code: text
        };
      }
      return {
        status: 'reject',
        code: 'please.check.your.file'
      };
    }
  };
  return {
    uploadImage
  };
};